import { render, staticRenderFns } from "./model_tag.vue?vue&type=template&id=c73ad148&scoped=true"
import script from "./model_tag.vue?vue&type=script&lang=ts"
export * from "./model_tag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73ad148",
  null
  
)

export default component.exports